import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class IM4EntryService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get vehicles pending entry
   * @returns Array
   */
  getVehiclesPendingEntry(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/vehicles/pending-im4-entry`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get single vehicle record
   * @param vehicle_id
   */
  getVehicle(vehicle_id: string){

    let apiURL:string=`${this.baseURL}/v1/get-vehicle/${vehicle_id}`;

    return this.http.get(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));

  }

  /**
   * Save entry
   */
  addEntry(entry_data:any,entry_attachment:any,assmt_notice_attachment:any,vehicle_id: string|null):Observable<any>{
    const formData = new FormData();
    formData.append("chassis_no", entry_data.chassis_no);
    formData.append("entry_no", entry_data.entry_no);
    formData.append("entry_date", entry_data.entry_date);
    formData.append("duty_amount", entry_data.duty_amount);
    formData.append('entry_attachment', entry_attachment);
    formData.append('assmt_notice_attachment', assmt_notice_attachment);
    formData.append("bl_no", entry_data.bl_no);

    let apiURL:string=`${this.baseURL}/v1/add-im4-entry/${vehicle_id}`;

    return this.http.post(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Filter imported vehicles
   */
  filterVehiclesPendingEntry(startDate:any,endDate:any):Observable<any>{
    const formData = new FormData();
    formData.append("eta_start_date", startDate);
    formData.append("eta_end_date", endDate);

    let apiURL:string=`${this.baseURL}/v1/filter-vehicles-pending-im4-entry`;

    return this.http.post(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }
}
